import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

export default function FloatingButtons() {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col space-y-3 z-50">
      {/* Botón WhatsApp */}
      <a
        href="https://wa.me/5213211009701"
        target="_blank"
        rel="noreferrer"
        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg flex items-center justify-center w-14 h-14"
      >
        <FontAwesomeIcon icon={faWhatsapp} className="text-2xl" />
      </a>

      {/* Botón Ubicación */}
      <a
        href="https://www.google.com/maps?q=L%C3%B3pez+Ray%C3%B3n+18,+El+Grullo,+Jalisco"
        target="_blank"
        rel="noreferrer"
        className="bg-yellow-500 hover:bg-yellow-600 text-white rounded-full p-4 shadow-lg flex items-center justify-center w-14 h-14"
      >
        <FontAwesomeIcon icon={faMapMarkerAlt} className="text-2xl" />
      </a>
    </div>
  );
}